// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3SVfq","title":"InfoRow_title__37nKp"};